import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddCircleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_circle_outline"}/>
}
